module.exports = __webpack_public_path__ + "img/maintenance.a098535f.jpg";